import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import { location_categories_list } from "../../Shared/List"
import FileField from "../../Shared/FileField"

const UpdateLocationForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [categoryOptions, setCategoryOptions] = useState([])
  const [zoneOptions, setZoneOptions] = useState([])
  const [villageOptions, setVillageOptions] = useState([])
  const [lineOptions, setLineOptions] = useState([])
  const [stationOptions, setStationOptions] = useState([])
  const [rateOptions, setRateOptions] = useState([])
  const [customerOptions, setCustomerOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([])
  const [selectedVillage, setSelectedVillage] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);

  const [formData, setFormData] = useState({
    category: "",
    remark: "",
    contact_number: "",
    customer_id: "",
    zone_id: "",
    village_id: "",
    line_id: "",
    station_id: "",
    rate_id: "",
    group_id: "",
    date: new Date().toISOString().slice(0, 10),
    description: "",
    contract: "",
    contractLable: true
  })
  const {category, remark, contact_number, customer_id, zone_id, village_id, line_id, station_id, rate_id, public_id, group_id, date, description, contract, contractLable} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {data} = location.state
        const category_obj = location_categories_list.find(category => category.name === data.category)
        setFormData((prev) => ({
            ...prev,
            remark: data.remark,
            contact_number: data.location_contact,
            customer_id: data.customer_id,
            zone_id: data.zone_id,
            village_id: data.village_id,
            line_id: data.line_id,
            station_id: data.station_id,
            group_id: data.group_id,
            rate_id: data.rate_id,
            public_id: data.public_id,
            date: data.date,
            category: category_obj?.id || 1,
            description: data.description,
            contractLable: data.contract === null ? "Contract(Optional)" : "Contract(Optional - Exist)"
        }));

        setSelectedVillage({ value: data.village_id });
        setSelectedStation({ value: data.station_id });

        setCategoryOptions(location_categories_list.map(category => ({
            id: category.id,
            key: category.key,
            name: category.name
        })));
    }

}, [location.state]);

useEffect(() => {
    if (selectedVillage?.value) {
      loadOptions('village-zones', '', setZoneOptions, selectedVillage.value)
        .then((response) => {
          const zones = [{ id: null, key: "", name: "-- please select zone --" }];
          response.forEach((zone) => {
            zones.push({ id: zone.value, key: zone.public_id, name: zone.label });
          });
          setZoneOptions(zones);
        });
    }
  }, [selectedVillage]);
  
  useEffect(() => {
    if (selectedStation?.value) {
      loadOptions('station-lines', '', setLineOptions, null, selectedStation.value)
        .then((response) => {
          const lines = [{ id: null, key: "", name: "-- please select line --" }];
          response.forEach((line) => {
            lines.push({ id: line.value, key: line.public_id, name: line.label });
          });
          setLineOptions(lines);
        });
    }
  }, [selectedStation]);

    // 4. Watch for formData.customer_id and then load customer options
    useEffect(() => {
        if (formData.customer_id) {
            loadCustomerOptions(formData.customer_id);
        }
    }, [formData.customer_id]);

    // Load options dynamically from a remote source
    const loadCustomerOptions = async (query) => {
        try {
            const response = await Server.get('/options/customers', {
            params: { q: query },
            });
            setCustomerOptions(response.data)
            return response.data;
        } catch (error) {
          return [];
        }
    };

    const loadOptions = async (url, query, setOptions, villageId=null, stationId=null) => {
        try {
            const params = { q: query };
            
            if (url === 'village-zones' && villageId) {
                params.village_id = villageId; // Send village_id only when loading zones
            }

            if (url === 'station-lines' && stationId) {
                params.station_id = stationId; // Send station_id only when loading zones
            }

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

  const onChange = (e) => {
    const { name, files, value } = e.target;
    // const value = e.target.value === "" ? null : e.target.value;
    setFormData((prev) => {
      const isFile = name === "contract";
      const newValue = isFile ? files[0] : value;
      return {
        ...prev,
        [name]: newValue,
      };
    });

        // change zoneOptions when village is selected
        if (name === 'village_id'){
            setSelectedVillage(e.target);
        }

        // change lineOptions when station is selected
        if (name === 'station_id'){
            setSelectedStation(e.target);
        }
    }

  const onSubmit = (e) => {
      e.preventDefault()

      //find category name with its index
        const category_name = location_categories_list[formData?.category - 1]?.name || 'Mulkiile'
      const payload = {category: category_name, remark, contact_number, customer_id, zone_id, line_id, rate_id, group_id, date, description, contract}
      updateLocation(payload)
  }
  
  // update location
  const updateLocation = async (payload) => {
      setIsLoading(true);

      const dataToSend = new FormData();
      dataToSend.append("contract", payload.contract);
      dataToSend.append("category", payload.category);
      dataToSend.append("remark", payload.remark);
      dataToSend.append("contact_number", payload.contact_number);
      dataToSend.append("customer_id", payload.customer_id);
      dataToSend.append("zone_id", payload.zone_id);
      dataToSend.append("rate_id", payload.rate_id);
      dataToSend.append("date", payload.date);
      if (payload.group_id) dataToSend.append("group_id", payload.group_id);
      if (payload.line_id) dataToSend.append("line_id", payload.line_id);
      if (payload.description) dataToSend.append("description", payload.description);

      try {
          const response = await Server.put(`/locations/${public_id}`, dataToSend, {headers: {'Content-Type': 'multipart/form-data'}})
          if (response.status === 200){
              navigate('/locations-serverside')
              setIsLoading(false)
              toast.success('Successfully updated')
          }else{
              toast.error(response.data?.detail)
          }
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422) {
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            setErrors(error.response.data?.detail)
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
            <h3 className="card-title">Update Location Form</h3>
        </div>
        <div className="card-body">
            <form onSubmit={onSubmit}>
                <div className="row">
                    <div className="col-md-5">
                        <AsyncSelectField
                            name="customer_id"
                            label="Customer"
                            value={customerOptions.find((option) => option.value === formData.customer_id)?.value ?? 0}
                            onChange={onChange}
                            loadOptions={loadCustomerOptions}
                            options={customerOptions}
                            placeholder="Start typing to search..."
                            error={errors.customer_id}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputField
                            placeholder="Remark"
                            name="remark"
                            type="text"
                            label="Remark"
                            value={remark}
                            onChange={onChange}
                            error={errors.remark}
                        />
                    </div>
                    <div className="col-md-2">
                        <InputField
                            placeholder="Contact"
                            name="contact_number"
                            type="text"
                            label="Location Contact"
                            value={contact_number}
                            onChange={onChange}
                            error={errors.contact_number}
                        />
                    </div>
                    <div className="col-md-2">
                        <SelectField
                            name="category"
                            label="Category"
                            value={parseInt(category)}
                            options={categoryOptions}
                            onChange={onChange}
                            error={errors.category}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <AsyncSelectField
                            name="group_id"
                            label="Group"
                            value={group_id}
                            onChange={onChange}
                            loadOptions={(query) => loadOptions('location-groups', query, setGroupOptions)}
                            options={groupOptions}
                            placeholder="Start typing to search..."
                            error={errors.group_id}
                        />
                    </div> 
                    <div className="col-md-3">
                        <AsyncSelectField
                            name="rate_id"
                            label="Rate"
                            value={rate_id}
                            onChange={onChange}
                            loadOptions={(query) => loadOptions('rates', query, setRateOptions)}
                            options={rateOptions}
                            placeholder="Start typing to search..."
                            error={errors.rate_id}
                        />
                    </div>
                    <div className="col-md-3">
                        <AsyncSelectField
                            name="village_id"
                            label="Village"
                            value={village_id}
                            onChange={onChange}
                            loadOptions={(query) => loadOptions('villages', query, setVillageOptions)}
                            options={villageOptions}
                            placeholder="Start typing to search..."
                            error={errors.village_id}
                        />
                    </div>
                    <div className="col-md-3">
                        <SelectField
                            name="zone_id"
                            label="Zone"
                            value={parseInt(zone_id)}
                            options={zoneOptions}
                            onChange={onChange}
                            error={errors.zone_id}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <AsyncSelectField
                            name="station_id"
                            label="Station"
                            value={station_id}
                            onChange={onChange}
                            loadOptions={(query) => loadOptions('stations', query, setStationOptions)}
                            options={stationOptions}
                            placeholder="Start typing to search..."
                            error={errors.station_id}
                        />
                    </div>
                    <div className="col-md-3">
                        <SelectField
                            name="line_id"
                            label="Line (Optional)"
                            value={parseInt(line_id)}
                            options={lineOptions}
                            onChange={onChange}
                            error={errors.line_id}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputField
                            name="date"
                            type="date"
                            label="Date"
                            value={date}
                            onChange={onChange}
                            error={errors.date}
                        />
                    </div>
                    <div className="col-md-3">
                        <FileField
                            name="contract"
                            type="file"
                            label={contractLable}
                            value={contract}
                            onChange={onChange}
                            error={errors.contract}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <NullableInput
                            placeholder="Location Detail"
                            name="description"
                            type="text"
                            label="Description (Optional)"
                            value={description}
                            onChange={onChange}
                            error={errors.description}
                        />
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-12">
                        <input type="submit" className="btn btn-outline-info" value="Update Location" style={{float: 'right'}}/>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <br/>
  </>
)
}

export default UpdateLocationForm
